import React, { Component } from 'react';
import NProgress from 'nprogress'

import Train from '../../services/train.js';
import Grid from '../Grid';

class UserSuggestions extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      overallSuggestedArtists: undefined,
      semesterlySuggestedArtists: undefined,
      monthlySuggestedArtists: undefined,
      weeklySuggestedArtists: undefined
    }
  }

  componentDidMount() {
    this.fetchData(this.userId());
  }

  userId() {
    return this.props.match.params.user;
  }

  fetchData(userId) {

    NProgress.start();

    let promises = ['overall', 'semesterly', 'monthly', 'weekly'].map((period) => {

      return Train.fetchUserArtistSuggestions({user: userId, period: period})
      .then((suggestions) => {
        return {name: `${period}SuggestedArtists`, suggestions};
      });

    });

    Promise.all(promises)
    .then((results) => {
      let state = results.reduce((state, result) => {
        state[result.name] = result.suggestions;
        return state;
      }, {});
      this.setState(state);
      NProgress.done();
    });

  }

  suggestedArtists() {
    return {
      overall: this.state.overallSuggestedArtists,
      semesterly: this.state.semesterlySuggestedArtists,
      monthly: this.state.monthlySuggestedArtists,
      weekly: this.state.weeklySuggestedArtists
    };
  }


 render() {

    return (
      <div>
        <Grid title="Suggested artists" playable={true} mappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="suggested_artists" type="artist" hasPeriods={true} elements={this.suggestedArtists()} />
      </div>
    ); 

  }
}

export default UserSuggestions;



// WEBPACK FOOTER //
// ./src/js/components/user/UserSuggestions.jsx